<template>
  <div>
    <provider-detail-component />
  </div>
</template>

<script>
export default {
  name: "ProviderDetail",
};
</script>